<template>
	<div class="section-container">
		<div class="d-flex mb-4 section-title-container wrap txt-center align-center">
			<card-svg />
			<h2 class="uppercase bold section-title txt-left">Método de pago</h2>
		</div>
		<section class="button-selection mb-3">
			<special-button
				v-if="paymentsMethodsInstance.showCreditCard()"
				class="mx-1"
				text="Tarjeta de crédito o débito"
				icon="el-icon-bank-card"
				:value="creditCardElection"
				@on-click="clicked(creditCardCode)"
			>
				<credit-cardSvg slot="svg" :active="creditCardElection"/>
			</special-button>
			<special-button
				v-if="paymentsMethodsInstance.showPayUponReceipt()"
				class="mx-1"
				text="Paga tu producto al recibir"
				icon="el-icon-money"
				:value="takeItAndPayIt"
				@on-click="clicked(takeItAndPayItCode)"
			>
				<pay-svg slot="svg" :active="takeItAndPayIt"/>
			</special-button>
			<special-button
				v-if="paymentsMethodsInstance.showBankDeposit()"
				class="mx-1"
				text="Banca por Internet o Deposito"
				icon="el-icon-guide"
				:value="internetBank"
				@on-click="clicked(internetBankCode)"
			>
				<museum-svg slot="svg" :active="internetBank"/>
			</special-button>
		</section>
		<section v-show="creditCardElection" v-loading="isLoading">
			<CreditCardDistributor
				:gateway-configuration="commerceCreditCard"
			/>
		</section>
		<section class="pay-it fontS14 mx-1" v-if="takeItAndPayIt" v-loading="isLoading">
			<p><b>¡Haz tu pedido ahora y págalo en efectivo al recibir tu producto!</b></p>
			<p>Recuerda que si no podrás estar presente para la entrega, debes dejar a un tercero con el monto exacto a pagar.</p>
			<p>Y si no estás satisfecho con tu producto, puedes devolverlo completamente gratis dentro de los 10 días naturales posteriores a la entrega (se aplican términos y condiciones).</p>
		</section>
			<section
			class="bank fontS14 mx-1"
			v-if="internetBank"
			v-loading="isLoading"
		>
			<div>
				<div>
					<span>
						<el-radio
							v-for="(bankAccounts, bankKey, indexBank) in banks"
							:key="indexBank"
							:label="bankKey"
							:value="selectedBankAccount"
							v-model="selectedBankAccount"
						>
							<label class="fontAvenirBold fontS12 my-1">{{bankAccounts[0].getBankName()}}</label>
						</el-radio>
					</span>
				</div>
			</div>
			<div class="mt-2">
				<ul class="mb-1">
					<li
						v-for="account in selectedBank"
						:key="account.id"
						class="d-flex align-center my-1 bank-account"
					>
						<div>
							<div class="bank-account-number">
								<h4
									class="bank-account-info fontAvenirBold my-0"
								>{{account.getBankAccountName()}}:</h4>
								<h3 class="fontS20 my-0">{{account.getBankAccountNumber()}}</h3>
							</div>
							<div class="bank-account-owner">
								<h5 class="my-0">A Nombre de: <span class="owner-info"> {{ account.getBankPersonName()}}</span></h5>
								<h5 class="my-0">Documento de Identidad: <span class="owner-info">{{ account.getBankpersonDocumentNumber() }}</span></h5>
								<h5 class="my-0">Correo: <span class="owner-info">{{ account.getBankdocumentEmail() }}</span></h5>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import specialButton from '@/components/buy/specialButton';
import paySvg from '@/components/svg-components/paySvg';
import creditCardSvg from '@/components/svg-components/creditCardSvg';
import museumSvg from '@/components/svg-components/museumSvg';
import cardSvg from '@/components/svg-components/cardSvg';
import PaymentMethods from '@/class/PaymentsMethods';
import commerceData from '@/mixins/commerceData';
import CreditCardDistributor from '@/components/buy/creditCardDistributor';
import { creditCard, deposit, reciveAndPay } from '@/shared/enums/wayPayment';
import lib from '@/helpers/lib';

const { getDeeper } = lib;

function createPaymentsMethodsInstance() {
	const bankAccounts = this.getCommerceData.bankAccountsRelated;
	const paymentsMethods = this.wayPaymentCommerce;
	this.paymentsMethodsInstance = new PaymentMethods(paymentsMethods, bankAccounts);
	if (this.getCommerceData.bankAccountsRelated[0]) {
		this.selectedBankAccount = this.getCommerceData.bankAccountsRelated[0].bankId.toString();
	}
	this.setPaymentMethod();
}

function setPaymentMethod() {
	const creditCardExist = this.wayPaymentCommerce.find(c => c.code === creditCard.code);
	if (creditCardExist) {
		this.clicked(creditCard.code);
	} else {
		const firstMethod = this.wayPaymentCommerce[0];
		this.clicked(firstMethod.code);
	}
}

function creditCardCode() {
	return creditCard.code;
}

function creditCardElection() {
	return this.active === this.creditCardCode;
}

function takeItAndPayItCode() {
	return reciveAndPay.code;
}

function takeItAndPayIt() {
	return this.active === this.takeItAndPayItCode;
}

function internetBankCode() {
	return deposit.code;
}

function internetBank() {
	return this.active === this.internetBankCode;
}

function clicked(code) {
	this.active = code;
	this.$store.commit('SET_VISA_PAYMENT_FLAG', false);
	if (code === creditCard.code) {
		this.$store.commit('SET_VISA_PAYMENT_FLAG', true);
	}
	const wayPayment = this.wayPaymentCommerce.find(w => w.code === code);
	const bankAccountId = wayPayment.code === deposit.code ? 1 : null;
	this.$store.commit('SET_WAY_PAYMENT', { wayPayment: wayPayment.wayPaymentId, bankAccountId });
}

function beforeDestroy() {
	location.reload();
}

function banks() {
	return this.paymentsMethodsInstance.getBanks();
}

function selectedBank() {
	return this.paymentsMethodsInstance.getBankAccounts(this.selectedBankAccount);
}

function wayPaymentCommerce() {
	return getDeeper('wayPaymentCommerce')(this.getCommerceData);
}

function commerceCreditCard() {
	const creditCards = this.wayPaymentCommerce.find(w => w.code === creditCard.code);
	const { gatewayConfiguration } = creditCards || {};
	return gatewayConfiguration;
}

function data() {
	return {
		active: '',
		companyLogo: process.env.COMPANY_LOGO,
		expirationTime: null,
		formFunction: null,
		isLoading: false,
		logo: {
			bcp: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/logo-bcp.png',
			bbva: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/logo-bbva.png',
		},
		merchantId: process.env.VISA_MERCHAN_ID,
		paymentsMethodsInstance: new PaymentMethods([], []),
		selectedBankAccount: null,
		totalAmount: null,
		waysPayment: [],
	};
}

export default {
	name: 'payment-methods',
	beforeDestroy,
	components: {
		cardSvg,
		CreditCardDistributor,
		creditCardSvg,
		museumSvg,
		paySvg,
		specialButton,
	},
	computed: {
		...mapGetters([
			'getWayPaymentByCommerce',
			'flagPickUp',
			'getCommerceData',
			'getTotalAmount',
			'orderSummaryInfo',
			'token',
			'totalProducts',
			'shippingCostAmount',
			'visaToken',
		]),
		banks,
		commerceCreditCard,
		creditCardElection,
		creditCardCode,
		internetBank,
		internetBankCode,
		selectedBank,
		takeItAndPayIt,
		takeItAndPayItCode,
		wayPaymentCommerce,
	},
	data,
	methods: {
		clicked,
		createPaymentsMethodsInstance,
		setPaymentMethod,
	},
	mixins: [commerceData],
	watch: {
		'getCommerceData.wayPaymentCommerce': createPaymentsMethodsInstance,
	},
};
</script>
<style lang="scss" scoped>
	.button-selection {
		align-items: center;
		display: grid;
		flex-wrap: wrap;
		grid-gap: 1rem;
		grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
	}

	.img-banks {
		height: 8.3rem;
		width: 35.6rem;

		@media (max-width: 500px) {
			margin: 0 auto;			
			width: 30.6rem;
		}
	}

	.img-credit-card {
		height: 4.2rem;
		width: 13.6rem;
	}

	.pay-it,
	.bank {
		@media (max-width: 500px) {
			text-align: center;
		}
	}

	.btn-visa {
		border: 1px solid;
		margin-left: 10px;
		padding: 0px;
	}

	.title-account {
		font-family: font(avenirBold);
		font-size: size(medium);
	}

	.item-account {
		font-family: font(avenirDemi);
		font-size: size(medium);
	}

	.box-account {
		padding: 0.5rem 1.7rem;
	}

	.min-width {
		max-width: 46.0rem;
	}

	.american {
		height: 3rem !important;
		margin-bottom: 0.75rem;
		width: 7.2rem;
	}

	.dinners {
		height: 3rem !important;
		margin-bottom: 0.75rem;
		width: 8.5rem;
	}

	.bank-account {
		padding: 2rem 2rem 1rem 2rem;
	}

	.bank-account:nth-child(even) {
		background-color: color(input);
	}

	.bank-account-info {
		color: color(textBoldGrey);
		margin-right: 1rem;
	}
	.section-container {
		padding: 5rem 0;
	}

	.bank-account-number {
		align-items: center;
		display: flex;
		flex-direction: row;
	}

	.bank-account-owner {
		color: color(blackBold);
		line-height: 2rem;
		margin-left: 1rem;
		margin-bottom: 1.5rem;

		.owner-info {
			color: color(textBoldGrey);
			font-family: font(avenirBold);
		}
	}
</style>



// WEBPACK FOOTER //
// paymentMethods.vue?8609de7c